import axios from 'axios';
import { ElMessage } from 'element-plus';

// 创建 axios 实例
const request = axios.create({
  baseURL: '/api', // 基础URL，统一使用 /api 代理路径
  timeout: 30000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，比如添加认证token
    
    // 检查当前页面是否属于管理后台
    // 如果当前页面路径包含 /admin，则使用 adminToken
    const isAdminPage = window.location.pathname.includes('/admin');
    
    if (isAdminPage) {
      // 管理后台使用 adminToken
      const adminToken = localStorage.getItem('adminToken');
      if (adminToken) {
        config.headers['token'] = adminToken;
      }
    } else {
      // 普通用户端使用 token
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['token'] = token;
      }
    }
    
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    console.error('Response error:', error);
    
    // 检查是否为管理端页面
    const isAdminPage = window.location.pathname.includes('/admin');
    
    // 检查错误状态码或业务错误码
    if (error.response) {
      const { status, data } = error.response;
      
      // 检查是否为认证失败（401或403）
      // 或者后端返回的业务错误码表示token无效或过期
      if ((status === 401 || status === 403) && isAdminPage) {
        // 清除管理端token
        localStorage.removeItem('adminToken');
        
        // 显示错误消息
        ElMessage.error('登录已过期，请重新登录');
        
        // 跳转到管理端登录页面
        window.location.href = '/admin/login';
      } 
      // 检查后端返回的业务错误码
      else if (isAdminPage && (data && (data.code === 401 || data.code === 1401 || data.msg?.includes('token') || data.message?.includes('token')))) {
        // 清除管理端token
        localStorage.removeItem('adminToken');
        
        // 显示错误消息
        ElMessage.error('登录已过期，请重新登录');
        
        // 跳转到管理端登录页面
        window.location.href = '/admin/login';
      }
      // 处理用户端的401和403错误
      else if ((status === 401 || status === 403) && !isAdminPage) {
        // 清除用户端token
        localStorage.removeItem('token');
        
        // 显示错误消息
        if (status === 401) {
          ElMessage.error('请先登录');
        } else {
          ElMessage.error('请重新登录');
        }
        


        window.location.href = '/login';

      }
    }
    
    return Promise.reject(error);
  }
);

export default request;